import { getElements } from 'js-utils/src/selector';
import { addEventListener } from 'js-utils/src/event';
import { toggleClass } from 'js-utils/src/attribute';
import { showSmartOutline } from 'js-utils/src/smart-outline';
import initFocusTrap from 'focus-trap';

import init from '../../common/base/init';

// Toggling on mobile
// Can be toggled on by any button that has `.js--sidebar-trigger` class

init(() => {
  const triggers = getElements('.js--sidebar-user-trigger');
  const sidebar = document.querySelector('.sidebar-user');
  if(!triggers.length || !sidebar) return;

  const closeBtn = document.querySelector('.sidebar-user__close');
  const activeTriggerClass = '--active';
  const activeSidebarClass = '--active';
  const focusTrap = initFocusTrap(sidebar);

  addEventListener(triggers, 'click', (e) => {
    e.preventDefault();
    const isActive = sidebar.classList.contains(activeSidebarClass);
    toggleClass(triggers, activeTriggerClass, !isActive);
    sidebar.classList.toggle(activeSidebarClass, !isActive);
    document.documentElement.classList.toggle('--disable-scroll', !isActive);

    if(!isActive) {
      focusTrap.activate();
      closeBtn.focus();
      showSmartOutline();
    }
  });

  addEventListener(closeBtn, 'click', function(e) {
    e.preventDefault();
    focusTrap.deactivate();
    triggers[0].click();
  });

  // deactivate on link click because of Turbolinks
  // addEventListener(getElements('a', sidebar), 'click', (e) => {
  //   if(!e.defaultPrevented) {
  //     focusTrap.deactivate();
  //   }
  // });
});
